export default __webpack_public_path__ + "static/media/PipelinePlus_Horizontal_Logo_RGB_Full_Color.33d9b04f.svg";